import { render, staticRenderFns } from "./seatBinding.vue?vue&type=template&id=6a3bbff5&"
import script from "./seatBinding.vue?vue&type=script&lang=js&"
export * from "./seatBinding.vue?vue&type=script&lang=js&"
import style0 from "./seatBinding.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports